import React from "react";
import { MuxDragHandle2, MuxX } from "@/Icons/PtIcons";
import { getTypeLabel } from "../utils";
import { useFormLayoutLabels } from "@/contexts/translation.context";

interface Field {
  id: string;
  name: string;
  label: string;
  type?: string;
  icon?: string;
  readOnly?: boolean;
  mandatory?: boolean;
  hidden?: boolean;
}

interface FieldItemProps {
  field: Field;
  isDragging?: boolean;
  showDropIndicator?: boolean;
  onRemove?: () => void;
}

export const FieldItem: React.FC<FieldItemProps> = ({
  field,
  isDragging,
  showDropIndicator,
  onRemove,
}) => {
  const labels = useFormLayoutLabels();
  return (
    <div
      className={`field-item ${isDragging ? "dragging" : ""} ${showDropIndicator ? "drop-target" : ""}`}
    >
      <div className="drag-area">
        <MuxDragHandle2 />
      </div>
      <div className="field-info">
        <span className="field-name">
          {field.label}
          {field.mandatory && <span className="mandatory">*</span>}
        </span>
        <span className="field-type">{getTypeLabel(field.type)}</span>
      </div>
      {onRemove && (
        <div className="field-actions">
          <button
            disabled={field.readOnly}
            className="icon-button"
            onClick={(e) => {
              e.stopPropagation();
              !field.readOnly && onRemove();
            }}
            type="button"
            title={field.readOnly ? "" : labels.removeField}
            aria-label={field.readOnly ? "" : labels.removeField}
          >
            <MuxX />
          </button>
        </div>
      )}
    </div>
  );
};
